import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import { Suspense } from "react";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import PlanSelection from "@/atomic/organisms/PlanSelection";
import useI18n from "@/hooks/useI18n";

export default function RechargeFinishedView({
  goBack,
  gotToHome,
  isVisibleModal,
  toggleModal,
  invoice,
  generatePDF,
  isLoading,
  openInvoice,
  error,
  toggleError,
}: PropsView) {
  const { t } = useI18n();

  return (
    <div className="relative flex flex-col">
      <Header title="Pagamento" hasLeftButton goBack={goBack} />
      <main className="px-4 py-3 md:py-6 flex flex-col items-center h-[calc(100vh-72px)] overflow-y-auto bg-white">
        <article className="flex flex-col w-full items-center">
          <div className="flex flex-col w-full max-w-[1400px] mx-auto">
            <div className="flex items-center justify-center w-full flex-col gap-[14px] mt-6 md:mt-10 mb-4 md:mb-6">
              <div className="w-20 h-20 bg-[#e5f9f2] rounded-full flex items-center justify-center p-5 shrink-0">
                <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#10b981"
                    strokeWidth={2.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col items-center justify-center w-full max-w-[328px]">
                <h2 className="text-[30px] font-extrabold text-[#0e0d0d] text-center leading-[1.1] tracking-[-0.5px]">
                  {t("pages:success:congratulations")}
                </h2>
                <p className="text-base text-center text-[#525252] leading-[1.35] mt-1">
                  {t("pages:success:description")}
                  <br />
                  <button
                    type="button"
                    onClick={openInvoice}
                    className="underline text-[#525252] hover:opacity-80"
                  >
                    {t("pages:success:viewReceiptInline")}
                  </button>
                </p>
              </div>
            </div>

            <div className="flex justify-center items-center w-full mx-auto mb-3 md:mb-6">
              <PlanSelection />
            </div>

            <div className="w-full max-w-full md:w-[calc(480px)] mx-auto">
              <div className="flex items-center flex-col mt-3 md:mt-6 px-2 my-4">
                <button
                  onClick={gotToHome}
                  type="button"
                  className="w-full h-[calc(50px)] md:h-[calc(60px)] rounded-lg border border-black bg-white text-black font-medium text-sm md:text-base"
                >
                  {t("pages:success:goToHome")}
                </button>
              </div>
            </div>
          </div>
        </article>
      </main>
      {isVisibleModal && (
        <Suspense fallback={null}>
          <TicketModal
            toggleModal={toggleModal}
            invoice={invoice}
            generatePDF={generatePDF}
          />
        </Suspense>
      )}
      {error && (
        <Suspense fallback={null}>
          <Modal
            title="Ops!"
            message="Seu recibo ainda não está disponível. Em alguns instantes você poderá visualizá-lo."
            actionMessage="Verificar novamente"
            action={() => {
              toggleError();
              openInvoice();
            }}
            actionSecondMessage="Ok, entendi"
            actionSecond={toggleError}
          />
        </Suspense>
      )}
      {isLoading && (
        <Suspense fallback={null}>
          <Loading />
        </Suspense>
      )}
    </div>
  );
}
